import PurchaseOrderTypes from './PurchaseOrderTypes';

export const getPurchaseOrderListInProgress = (payload) => {
  return { payload, type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_PROGRESS };
};

export const getPurchaseOrderListInSuccess = (payload) => {
  return { payload, type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_SUCCESS };
};

export const getPurchaseOrderListInError = (payload) => {
  return { payload, type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_ERROR };
};

export const setPurchaseOrderList = (payload) => {
  return { payload, type: PurchaseOrderTypes.SET_PURCHASE_ORDER_LIST };
};

export const setPurchaseOrderFilters = (payload) => {
  return { payload, type: PurchaseOrderTypes.SET_PURCHASE_ORDER_FILTERS };
};

export const setSelectedPurchaseOrders = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SELECTED_DATA,
  };
};

export const setPurchaseOrderModal = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SIDEBAR_TOGGLE,
  };
};

export const getPurchaseOrderInfoInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_PROGRESS,
  };
};

export const getPurchaseOrderInfoInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_ERROR,
  };
};

export const getPurchaseOrderInfoInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_SUCCESS,
  };
};

export const setPurchaseOrderInfo = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_INFO,
  };
};

export const setPurchaseOrderExportModal = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_EXPORT_TOGGLE,
  };
};

export const setDraftOrderSearchExportModal = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_DRAFT_ORDER_SEARCH_EXPORT_TOGGLE,
  };
};

export const setSelectedRegularOrders = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_REGULAR_ORDER_SELECTED_DATA,
  };
};

export const setReleaseOrderData = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_RELEASE_ORDER_DATA,
  };
};

export const setPurchaseOrderShipment = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SHIPMENT,
  };
};

export const setSelectAllItems = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_SELECT_ALL_CHECK,
  };
};

export const setCardView = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.PO_IS_CARD_VIEW,
  };
};

export const setTotalPORecords = (payload) => {
  return {
    payload,
    type: PurchaseOrderTypes.SET_TOTAL_PO_RECORDS,
  };
};

export const setPackingListData = (payload) => {
  return { payload, type: PurchaseOrderTypes.SET_PACKING_LIST_DATA };
};

export const tmsSettingUpdate = (payload) => {
  return { payload, type: PurchaseOrderTypes.PO_TMS_SETTINGS };
};
